import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';
import { ItemsService } from '../../../../services/api/general-settings/items.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-items-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './items-index-page.component.html',
  styleUrl: './items-index-page.component.scss'
})
export class ItemsIndexPageComponent {
list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected itemsService: ItemsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Items',
      cardTitle: 'Manage Items',
      addNewItemButton: {
        type: 'success',
        title: 'Add Item',
        onClick: () => {
          this.routeService.itemsCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'Code',
            header: 'Code',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'jurisdictionId',
            header: 'Jurisdiction',
            filter: 'select',
            filterOptionsSource: 'jurisdictions',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'itemProductId',
            header: 'Product',
            filter: 'select',
            filterOptionsSource: 'itemProducts',
            value: (item: any) => {
              return item.itemProduct.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'itemTypeId',
            header: 'Type',
            filter: 'select',
            filterOptionsSource: 'itemTypes',
            value: (item: any) => {
              return item.itemType.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'price',
            header: 'Price',
            value: (item: any) => {
              return item.price + ' €';
            }
          }),
          new DataTableColumnText({
            attribute: 'maxDiscountPercent',
            header: 'Max Discount',
            value: (item: any) => {
              return item.maxDiscountPercent + ' %';
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View item details',
                onClick: (item: any) => {
                  this.routeService.itemsDetail(item.itemId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit item',
                onClick: (item: any) => {
                  this.routeService.itemsUpdate(item.itemId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete item',
                onClick: (item: any) => {
                 
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.itemsService.list(options),
      responseListModelName: 'items',
    }
  }
}
